import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import { useHistory, useLocation } from 'react-router-dom';
import { CONTACT_NUMBER, TDD_TTY_NUMBER, WIZARD_URL } from 'shared';
import PreQualificationDeclinedAdsOnlyLanguage from '../components/PreQualificationDeclinedAdsOnlyLanguage';
function PreQualificationDeclinedAdsOnlyPage() {
    const history = useHistory();
    const redirectToWizard = () => {
        history.push({
            pathname: WIZARD_URL,
            state: {
                step: 'PRE-QUALIFICATION',
                fullApp: true,
            },
        });
    };
    const location = useLocation();
    const lenderStatusMessage = location?.state?.lenderStatusMessage;
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx("h1", { className: "first-title", children: "Pre-qualification" }), _jsx("p", { className: "first-subtitle", children: "Thank you for your interest in the Alphaeon Credit Card." }), _jsx("p", { children: _jsx(PreQualificationDeclinedAdsOnlyLanguage, { lenderStatusMessage: lenderStatusMessage, redirectToWizard: () => redirectToWizard() }) }), _jsxs("div", { className: "info-container", children: [_jsx(LocalPhoneIcon, {}), ' ', _jsxs("div", { className: "number-container", children: [_jsx("div", { children: _jsx("a", { href: `tel:${CONTACT_NUMBER}`, children: CONTACT_NUMBER }) }), ' ', _jsx("div", { children: _jsxs("a", { href: `tel:${TDD_TTY_NUMBER}`, children: ["(TDD/TTY ", TDD_TTY_NUMBER, ")"] }) })] })] })] }) }));
}
export default PreQualificationDeclinedAdsOnlyPage;
